import React, { useState, useEffect } from 'react';
import * as Progress from '@radix-ui/react-progress';

import styles from './progress-indicator.module.scss';
interface ProgressIndicatorProps {
  max: number;
  value: number;
  action?: React.ReactNode;
  label?: string;
}

export const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  max: num,
  value: curr,
  action,
  label,
}) => {
  const [progress, setProgress] = useState<number>(0);

  useEffect(() => {
    const currentProgress = (curr / num) * 100;
    setProgress(currentProgress);
  }, [curr, num]);

  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <div className={styles['label']}>{label}</div>
        {action}
      </div>
      <Progress.Root className={styles['root']} value={progress}>
        <Progress.Indicator
          className={styles['indicator']}
          style={{ transform: `translateX(-${100 - progress}%)` }}
        />
      </Progress.Root>
    </div>
  );
};
